import { FC, MouseEvent, SyntheticEvent } from 'react';
import clsx from 'clsx';

import { UnderlinedButton } from '@components/shared/buttons/underlined-button/UnderlinedButton';
import { Collapse } from '@components/shared/collapse/Collapse';
import { IFilterProp } from '@types';

interface IProps {
  classes: { [key: string]: string };
  label?: string;
  arraySelectedLast?: IFilterProp | null;
  arraySelectedLength?: number;
  handleReset?: (ev: SyntheticEvent | MouseEvent) => void;
}

const FilterLabel: FC<IProps> = ({ classes, label, arraySelectedLast, arraySelectedLength, handleReset }) => {
  const labelComputed = arraySelectedLast ? arraySelectedLast.label || arraySelectedLast.value : '';

  return (
    <>
      <h6 className={classes.expansionHeader}>{label}</h6>
      <Collapse in={true}>
        <div
          className={clsx(classes.expansionBottom, { [classes.expansionBottomMargin]: Boolean(arraySelectedLength) })}
          onClick={(ev) => ev.stopPropagation()}
        >
          <p className={classes.expansionDesc}>
            {labelComputed}
            {arraySelectedLength && arraySelectedLength > 1 ? ` + ${arraySelectedLength - 1}` : null}
          </p>

          {Boolean(arraySelectedLength) ? (
            <UnderlinedButton
              className={clsx(classes.expansionReset, {
                [classes.expansionResetActive]: !!arraySelectedLast
              })}
              onClick={handleReset}
              label="Скинути"
            />
          ) : null}
        </div>
      </Collapse>
    </>
  );
};

export default FilterLabel;
